<nz-input-number [(ngModel)]="controlValue" [nzMin]="csMin" [nzMax]="csMax" [nzStep]="csStep" [nzDisabled]="csDisable"
  (ngModelChange)="onModelChange($event)" [class.cs-number-hidden-step]="hiddenStep" [nzFormatter]="csFormatter"
  [nzPrecision]="csPrecision" [nzPlaceHolder]="csPlaceHolder | translate" [nzParser]="csParser" class="w-100"
                [nzPrecisionMode]="csPrecisionMode" (nzBlur)="onBlur()">
</nz-input-number>
